/**
 * SPRINT V2 — Impacto al Elegir Nación.
 * Emotional welcome moment when the user picks a nation. Pure local cue.
 */
const K = "vs:v2:impact:v1";

export interface NationImpactState {
  nation: string | null;
  shownAt: number;
}

const NATION_META: Record<string, { name: string; flag: string; accent: string; cry: string }> = {
  MEX: { name: "México",    flag: "🇲🇽", accent: "#1B8A2C", cry: "¡Vamos México!" },
  ARG: { name: "Argentina", flag: "🇦🇷", accent: "#75AADB", cry: "¡Vamos Argentina!" },
  BRA: { name: "Brasil",    flag: "🇧🇷", accent: "#FFCC29", cry: "Bora Brasil!" },
  USA: { name: "USA",       flag: "🇺🇸", accent: "#3C3B6E", cry: "Let's go USA!" },
  ESP: { name: "España",    flag: "🇪🇸", accent: "#AA151B", cry: "¡A por todas, España!" },
  FRA: { name: "France",    flag: "🇫🇷", accent: "#0055A4", cry: "Allez les Bleus!" },
  POR: { name: "Portugal",  flag: "🇵🇹", accent: "#006600", cry: "Força Portugal!" },
  COL: { name: "Colombia",  flag: "🇨🇴", accent: "#FCD116", cry: "¡Vamos Colombia!" },
};

function read(): NationImpactState { 
  if (typeof window === "undefined") return { nation: null, shownAt: 0 };
  try { return JSON.parse(window.localStorage.getItem(K) ?? "") as NationImpactState; }
  catch { return { nation: null, shownAt: 0 }; }
}
function write(s: NationImpactState) {
  if (typeof window === "undefined") return;
  try { window.localStorage.setItem(K, JSON.stringify(s)); } catch { /* noop */ }
}

export function nationMeta(code: string | null) {
  if (!code) return null;
  return NATION_META[code] ?? { name: code, flag: "🌎", accent: "#a855f7", cry: `¡Vamos ${code}!` };
}

/** Returns true the first time we see this nation choice (per device). */
export function shouldShowImpact(nation: string | null): boolean {
  if (!nation) return false;
  const cur = read();
  return cur.nation !== nation;
}

export function markImpactShown(nation: string | null) {
  if (!nation) return;
  write({ nation, shownAt: Date.now() });
}